import { AdjustmentClassificationEnum } from "../enums/adjustmentClassification.enum";
import { HazardCategory } from "../enums/hazardCategory.enum";

export class Agent {
    id: string;
    name: string;
    casId: string;
    agentForm: string;
    agentType: number;
    // DASH-3168: nullable — when unset on create the BE inherits it from the MasterAgent.
    hazardCategory?: HazardCategory | null;
    healthAdvisory: string;
    specificRecommendations: string;
    consequenceRating: number | null;
    groupId?: string;
    organizationLevelId: string;
    organizationLevelName?: string;
    adjustmentClassification: AdjustmentClassificationEnum;
    analyteId: string;
    addedToMySite?: boolean;
    addedAtSelectedOrgLevel?: boolean;
    agentGroupIds?: string[];
    masterAgentId: string;
    updatedByUserId?: string;
    updatedByUserName?: string;
    dateCreated?: string;
    dateUpdated?: string;
    deletedByUserId?: string | null;
    deletedByUserName?: string;
    deletedDate?: string | null;
    isDeleted?: boolean;
}

export class AgentRecordHistory extends Agent {
    entityId: string;
    reason?: string;
    changedFields?: string;
    changedFieldsArray?: string[];
    changedFieldSet?: Set<string>;
    dateUpdatedDisplay?: string;
    agentTypeDisplay?: string;
}
